import { COUNTRIES, getCountry } from "../utils/countries";
import { Input } from "./ui/input";
import { useI18n } from "../i18n";

// Selector de código de país (E.164) + input de número nacional
export default function PhoneInputIntl({ iso, onIsoChange, value, onChange, onBlur, error, testId, placeholder }) {
  const { t } = useI18n();
  const country = getCountry(iso);
  return (
    <div>
      <div className="flex gap-2">
        <select
          value={country.iso}
          onChange={(e) => onIsoChange(e.target.value)}
          className="h-12 rounded-xl bg-white/5 border border-white/10 text-white text-sm px-2 focus:border-[#1B84FF] outline-none max-w-[130px]"
          data-testid={testId ? `${testId}-dial-select` : undefined}
        >
          {COUNTRIES.map((c) => (
            <option key={c.iso} value={c.iso} className="bg-[#0B2545] text-white">
              {c.flag} +{c.dial}
            </option>
          ))}
        </select>
        <Input
          type="tel"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder || (country.iso === "PE" ? "987654321" : t("common.phone_ph"))}
          maxLength={country.max + 4}
          className={`h-12 flex-1 bg-white/5 border-white/10 text-white placeholder:text-slate-500 focus:border-[#1B84FF] focus:ring-[#1B84FF]/20 rounded-xl ${error ? "border-red-500" : ""}`}
          data-testid={testId ? `${testId}-input` : undefined}
        />
      </div>
      {error && (
        <p className="text-red-400 text-sm mt-1" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </p>
      )}
    </div>
  );
}
